import { groupFDAPI } from './../Services/API/groupfd.api'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storageSession from 'redux-persist/lib/storage/session'
import { userReducer } from 'features/Authentication'
import { examReducer } from 'features/Exam/exam.slice'
import { cartReducer } from 'features/Health/cart.health.slice'
import { memberDetailsReducer } from 'features/Health/memberDetails.health.slice'
import { homePageReducer } from 'features/Home'
import { vehicleDetailsReducer, quotationsReducer, proposalPageReducer } from 'features/Motor'
import { spTaggingReducer } from 'features/SpTagging.equitas.slice'
import { authenticationApi } from 'Services/API/authentication.api'
import { healthApi } from 'Services/API/health.api'
import { motorApi } from 'Services/API/motor.api'
import persistReducer from 'redux-persist/es/persistReducer'
import { bobPartnerApi } from 'Services/API/BOB/bob_partner.api'
import { bobProductApi } from 'Services/API/BOB/bob_product.api'
import { cbsDataReducer } from 'features/BobSellJourney/CbsData.slice'
import { suitabilityDataReducer } from 'features/BobSellJourney/SuitabilityData.slice'
import { planDataReducer } from 'features/BobSellJourney/PlanData.slice'
// import { existingPolicyDetailReducer } from 'features/BobSellJourney/existingPolicyDetail.slice'
// import { personalDetailReducer } from 'features/BobSellJourney/personalDetail.slice'
import { bobFoundationApi } from 'Services/API/BOB/bob_foundation.api'
import { bobMasterApi } from 'Services/API/BOB/bob_master.api'
// import { proposalStepReducer } from 'features/BobSellJourney/step.slice'
import { lifeQuotationReducer } from 'features/BobSellJourney/LifeQuotation.slice'
import { proposalStepReducer } from 'features/BobSellJourney/proposalStep.slice'
import { bobLmsApi } from 'Services/API/BOB/bob_lms.api'
import { bobOperationApi } from 'Services/API/BOB/bob_operation_api'
import { assuredAndPayorDetailsReducer } from 'features/BobSellJourney/AssuredAndPayorDetails.slice'
import { leadDetailsReducer } from 'features/Leads'
import { ckycReducer } from 'features/User/ckyc.slice'
import { fireReducer } from 'features/Fire/fire.slice'
import { bobFmsApi } from 'Services/API/BOB/bob_fms.api'
import { communicationApi } from 'Services/API/BOB/communication.api'
import { customer360Api } from 'Services/API/BOB/customer360/operations.api'
import { bobFmsApiReal } from 'Services/API/BOB/customer360/fms_file_upload.api'
import { surakshaCustomer360Api } from 'Services/API/BOB/customer360/suraksha.api'
import { masterCustomer360Api } from 'Services/API/BOB/customer360/master.api'
import { bobCMSAPI } from 'Services/API/BOB/customer360/cms.api'
import { bobHealthAPi360 } from 'Services/API/BOB/customer360/health.api'
import { sachetBgrReducer } from 'features/Sachet/sachetGgr.slice'
import { bgrApi } from 'Services/API/bgr.api'
import { fireApi } from 'Services/API/fire.api'
import { groupLifeReducer } from 'features/Group/grouplife.slice'
import { groupEMIReducer } from 'features/Group/groupEmi.slice'
import { groupFDReducer } from 'features/Group/groupFD.slice'
import { groupHealthReducer } from 'features/Group/groupHealth.slice'
import { travelReducer } from 'features/Travel/travel.slice'
import { travelApi } from 'Services/API/travel.api'
import { policyDataReducer } from 'features/Customer360'
import { groupHealthAPI } from 'Services/API/groupHealth.api'
import { pospUserReducer } from 'PospModule/features/Authentication'
import { pospApi } from 'PospModule/Services/API/posp.api'

const persistConfig = {
  key: `STORE_${process.env.REACT_APP_ENV}`,
  storage: storageSession,
  blackList: ['groupFDAPI', 'pospApi'],
  blacklist: ['policyData', 'pospApi'],
}

const policyDataPersistConfig = {
  key: `policyData_${process.env.REACT_APP_ENV}`,
  storage: storageSession,
}

const persistedPolicyDataReducer = persistReducer(policyDataPersistConfig, policyDataReducer)

const reducers = combineReducers({
  user: userReducer,
  fire: fireReducer,
  homePage: homePageReducer,
  vehicleDetails: vehicleDetailsReducer,
  quotationsDetails: quotationsReducer,
  proposalPage: proposalPageReducer,
  [authenticationApi.reducerPath]: authenticationApi.reducer,
  memberDetails: memberDetailsReducer,
  ckyc: ckycReducer,
  cart: cartReducer,
  [healthApi.reducerPath]: healthApi.reducer,
  [motorApi.reducerPath]: motorApi.reducer,
  [fireApi.reducerPath]: fireApi.reducer,
  leadDetails: leadDetailsReducer,
  spTagging: spTaggingReducer,
  communicationApi: communicationApi.reducer,
  travelReducer: travelReducer,
  // Sachet
  sachetBgr: sachetBgrReducer,
  groupLife: groupLifeReducer,
  groupEMI: groupEMIReducer,
  groupFD: groupFDReducer,
  groupHealth: groupHealthReducer,

  // BOB
  cbsData: cbsDataReducer,
  policyData: persistedPolicyDataReducer,
  [bobPartnerApi.reducerPath]: bobPartnerApi.reducer,
  [bobProductApi.reducerPath]: bobProductApi.reducer,
  [bobFoundationApi.reducerPath]: bobFoundationApi.reducer,
  [bobMasterApi.reducerPath]: bobMasterApi.reducer,
  [bobLmsApi.reducerPath]: bobLmsApi.reducer,
  [bobOperationApi.reducerPath]: bobOperationApi.reducer,
  [bobFmsApi.reducerPath]: bobFmsApi.reducer,
  [bgrApi.reducerPath]: bgrApi.reducer,
  [travelApi.reducerPath]: travelApi.reducer,
  suitabilityData: suitabilityDataReducer,
  planData: planDataReducer,
  lifeQuotation: lifeQuotationReducer,
  // existingPolicyDetail: existingPolicyDetailReducer,
  // personalDetail: personalDetailReducer,
  proposalStep: proposalStepReducer,
  assuredAndPayorDetails: assuredAndPayorDetailsReducer,

  // customer360
  [customer360Api.reducerPath]: customer360Api.reducer,
  [bobFmsApiReal.reducerPath]: bobFmsApiReal.reducer,
  [surakshaCustomer360Api.reducerPath]: surakshaCustomer360Api.reducer,
  [masterCustomer360Api.reducerPath]: masterCustomer360Api.reducer,
  [bobCMSAPI.reducerPath]: bobCMSAPI.reducer,
  [bobHealthAPi360.reducerPath]: bobHealthAPi360.reducer,
  // groupFD
  [groupFDAPI.reducerPath]: groupFDAPI.reducer,
  [groupHealthAPI.reducerPath]: groupHealthAPI.reducer,

  // POSP module
  pospUser: pospUserReducer,
  exam: examReducer,
  [pospApi.reducerPath]: pospApi.reducer,
})

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (gDM) =>
    gDM({ serializableCheck: false }).concat(
      authenticationApi.middleware,
      motorApi.middleware,
      healthApi.middleware,
      bobFoundationApi.middleware,
      bobPartnerApi.middleware,
      bobProductApi.middleware,
      bobMasterApi.middleware,
      bobLmsApi.middleware,
      bobOperationApi.middleware,
      bobFmsApi.middleware,
      communicationApi.middleware,
      customer360Api.middleware,
      bobFmsApiReal.middleware,
      surakshaCustomer360Api.middleware,
      masterCustomer360Api.middleware,
      bobCMSAPI.middleware,
      bgrApi.middleware,
      fireApi.middleware,
      bobHealthAPi360.middleware,
      groupFDAPI.middleware,
      travelApi.middleware,
      groupHealthAPI.middleware,
      pospApi.middleware,
    ),
  devTools: process.env.NODE_ENV !== 'production',
  // devTools: true,
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type ReducersState = ReturnType<typeof reducers>
